import React, {Component} from 'react';
import { VerificationForm } from '@sheerid/jslib';

class Home extends Component {
    render() {
        return (
            <div className="App">
                <img id="homeBG" src="1_military.jpg" alt="Military Demo" useMap="#applyButton" />
                <div id="form-container">
                    <VerificationForm programId={"5cce7162cac48b25b51f9bf3"} />
                </div>
            </div>
        );
    }
}

export default Home;
    